import React from 'react';
import ReactECharts from 'echarts-for-react';
import {
  labelStyle,
  titleStyle
} from '@/lomavisSharedUi/atoms/charts/chartTextStyles';
import { CHART_COLORS } from '@/lomavisSharedUi/atoms/charts/colors';

export interface LomavisDoughnutChart1Data {
  value: number;
  name: string;
  color?: string;
}

export interface LomavisDoughnutChart1Props {
  title?: string;
  data: LomavisDoughnutChart1Data[];
}

export const LomavisDoughnutChart1: React.FC<LomavisDoughnutChart1Props> = ({
  title,
  data
}) => {
  // Sort data by value in descending order
  const sortedData = [...data].sort((a, b) => b.value - a.value);

  const formattedData = sortedData.map(({ color, ...item }, index) => ({
    ...item,
    itemStyle: { color: color || CHART_COLORS[index % CHART_COLORS.length] }
  }));

  const option = {
    tooltip: {
      trigger: 'item',
      textStyle: labelStyle, // optional: apply to tooltip too
      formatter: function (params: LomavisDoughnutChart1Data) {
        // Calculate percentage
        // Return formatted tooltip with value and percentage
        return `${params.name}: ${params.value} %`;
      }
    },
    graphic: title
      ? [
          {
            type: 'text',
            left: 0, // ✅ Align to left
            top: 10, // ✅ Distance from top edge
            z: 100,
            style: {
              text: title,
              ...titleStyle,
              align: 'left', // ✅ Align text content to the left
              verticalAlign: 'top',
              backgroundColor: '#ffffff',
              padding: [4, 8],
              borderRadius: 4
            }
          }
        ]
      : [],

    series: [
      {
        name: title,
        type: 'pie',
        radius: ['40%', '70%'],
        avoidLabelOverlap: false,
        padAngle: 2,
        itemStyle: {
          borderRadius: 10,
          borderColor: '#fff',
          borderWidth: 2
        },
        label: {
          show: true,
          ...labelStyle,
          overflow: 'truncate',
          width: 125,
          ellipsis: true
        },
        emphasis: {
          label: {
            show: true,
            fontSize: 20,
            fontWeight: 'bold',
            overflow: 'truncate',
            width: 125,
            ellipsis: true
          }
        },
        data: formattedData
      }
    ]
  };

  return (
    <ReactECharts option={option} style={{ height: '100%', width: '100%' }} />
  );
};
